export const details = "פרטי שותף ושותפות";
export const currentMilga = "מלגה נוכחית: ";
export const approvalAmount = "סכום שאושר: ";
export const enteredAmount = "סכום שהוכנס: ";
export const sumEnteredAmount = "סה''כ סכום שהוכנס: ";
export const rowsNum = "שורות בקובץ: ";
export const rowsSumNum = 'סה"כ סכום כולל בקובץ: ';
export const sumAmount = 'סה"כ סכום זמין להכנסה: ';
export const amountLimit = "הגבלת סכום לאברך: ";
export const foodChain = "רשת מזון: ";
export const upload = "העלאת קובץ";
export const upload_button = "העלה";
export const exm_file = "לחצו כאן - להורדת קובץ להזנת נתונים";
export const upload_file = "לחצו כאן - להעלאת קובץ מלא";
export const empty_file = "הקובץ ריק";
export const high_sum = "הסכום הכולל גבוה מהסכום שנקבע";
export const update_sum = "עדכון סכום לשורות ריקות";
export const update_id_column = "תיקון דרכונים";
export const update_colel = "עדכון כולל לשורות ריקות";
export const update_idishCard = "עדכון אידישכארד 1 לשורות ריקות";
export const update_idishCard_2 = "עדכון אידישכארד 2 לשורות ריקות";
export const reupload = "העלאת קובץ חדש";
export const send_file = "שמירת ושליחת הקובץ";
export const tooltip = "לא כל השדות תקינים";
export const currency = " שח";
export const warning = "יש להעלות קובץ עם שמות עמודות זהות בדיוק לקובץ הדוגמא.\n מומלץ להוריד, למלא ולהעלות את קובץ לדוגמא ";
export const warning_2 = "משתמשים יקרים";
export const warning_3 = "אנא ואנא לפני כל שותפות חדשה אנא הורידו קובץ *חדש* והעלו אותו מלא, העמודות מתעדכנות מידי פעם וזה גורם לבעיות בקליטת קבצים מגרסאות קומות.";
export const info = "כדי לראות את השגיאה בשדות שגויים - יש להניח את העכבר על השדה"
export const idishcard_info = "חובה להזין מספרים בשדות אידיש כארד 1 ו- 2." +
    " במידה ואין לאברך כרטיס או שלא ידוע מה מספר הכרטיס, יש להזין 'אין כרטיס', ובמידה ויש כרטיס מחלוקה קודמת," +
    " אבל לא ידוע מה מספרו יש להזין 'יש כרטיס מחלוקה קודמת'."
export const idishcard_desc = "הסבר על עמודות אידישכארד - לחץ כאן לצפייה"

export const update_fields_for_all = "עדכון נתונים בקובץ";
export const close_popup = "סגור";

// Sort popup texts
export const sort_popup_title = "בחר אפשרות מיון";
export const sort_by_name = "מיון לפי שם משפחה";
export const sort_by_tz = "מיון לפי ת.ז.";

